module.exports = __webpack_public_path__ + "img/eligibility-mail.cedafe60.svg";